import React from "react";
import { TfiLocationPin } from "react-icons/tfi";

function LocationIcon({ className }) {
  return <TfiLocationPin className={className} />;
}

export default LocationIcon;
